<template>
    <Link :href="'/'">
        <img src="/images/logo/logo.svg" alt="logo" class="h-20">
    </Link>
</template>

<script>
import { Link } from '@inertiajs/vue2'

export default {
    components: {
        Link,
    },
}
</script>
